import styled from 'styled-components'
import React from 'react'

const IconWithAttributes = styled.i`
  font-size: inherit;
  margin-right: 0.5em;
`

interface ActivityMatchedIconProps {
  iconName?: string
  iconSize?: string
}

const ActivityMatchedIcon = ({
  iconName,
  iconSize,
}: ActivityMatchedIconProps) => {
  const className = `icon icon-${iconSize} icon-${iconName}`

  return <IconWithAttributes className={className} />
}

export default ActivityMatchedIcon
